/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Founder_Vaisakhan_NameInputs */

const en_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const de_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const fr_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const es_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const it_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const nl_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const pl_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const fi_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const da_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

const sv_about_founder_vaisakhan_name = /** @type {(inputs: About_Founder_Vaisakhan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu`)
};

/**
* | output |
* | --- |
* | "Vaisakhan Arackal Sanu" |
*
* @param {About_Founder_Vaisakhan_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_founder_vaisakhan_name = /** @type {((inputs?: About_Founder_Vaisakhan_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Founder_Vaisakhan_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_founder_vaisakhan_name(inputs)
	if (locale === "fr") return fr_about_founder_vaisakhan_name(inputs)
	if (locale === "es") return es_about_founder_vaisakhan_name(inputs)
	if (locale === "it") return it_about_founder_vaisakhan_name(inputs)
	if (locale === "nl") return nl_about_founder_vaisakhan_name(inputs)
	if (locale === "pl") return pl_about_founder_vaisakhan_name(inputs)
	if (locale === "fi") return fi_about_founder_vaisakhan_name(inputs)
	if (locale === "da") return da_about_founder_vaisakhan_name(inputs)
	if (locale === "sv") return sv_about_founder_vaisakhan_name(inputs)
	return en_about_founder_vaisakhan_name(inputs)
});